import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Alert, Button, Form, Row} from 'reactstrap';
import {Formik} from 'formik';
import Yup from 'yup';
import {
    Footer,
    InputSelect
} from '../../components';
import {toRegisterConfirmPage} from "../../actions/subscriber/subscribe";

class SubscribePayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: true,
            loadingCssName: "",
            nextDisabled: false
        }
    }

    componentDidMount() {
        this.fetchData(this.props.history);
    }

    fetchData(history) {
        const type = history.action
        if(type === 'POP') {
            this.props.history.push('/subscribers/subscribe');
        }
    }

    onFormSubmit = values => {
        if (this.state.canSubmit) {
            this.setState({canSubmit: false, loadingCssName: "buttonLoading", nextDisabled: true});
            this.props.toRegisterConfirmPage(values, this.props.history).then(() => {
                this.setState({canSubmit: true, loadingCssName: "", nextDisabled: false});
            });
        }
    };

    accountStatusOptions = () => {
        let states = [{key: '', value: ''}];
        states.push({key: 'cc_recurring', value: 'CC Recurring'});
        states.push({key: 'invoiced', value: 'Invoiced'});
        return states;
    };

    paymentOptipaymentOptionons = () => {
        let states = [{key: '', value: ''}];
        states.push({key: '1', value: 'Monthly'});
        states.push({key: '2', value: 'Quarterly'});
        states.push({key: '3', value: 'Six Months'});
        states.push({key: '4', value: 'Annual'});
        return states;
    };

    ccRecurringOptions = () => {
        let states = [{key: '', value: ''}];
        states.push({key: 'Recurring 1st', value: 'Recurring 1st'});
        states.push({key: 'Recurring 4th', value: 'Recurring 4th'});
        states.push({key: 'Recurring 7th', value: 'Recurring 7th'});
        states.push({key: 'Recurring 10th', value: 'Recurring 10th'});
        states.push({key: 'Recurring 13th', value: 'Recurring 13th'});
        states.push({key: 'Recurring 15th', value: 'Recurring 15th'});
        states.push({key: 'Recurring 18th', value: 'Recurring 18th'});
        states.push({key: 'Recurring 19th', value: 'Recurring 19th'});
        states.push({key: 'Recurring 21st', value: 'Recurring 21st'});
        states.push({key: 'Recurring 23rd', value: 'Recurring 23rd'});
        states.push({key: 'Recurring 25th', value: 'Recurring 25th'});
        states.push({key: 'Recurring 27th', value: 'Recurring 27th'});
        states.push({key: 'Recurring 29th', value: 'Recurring 29th'});
        return states;
    };

    renderErrors = errors => {
        if (!errors) return null;
        let values = Object.values(errors);
        return (
            <React.Fragment>
                {values.map(error => {
                    return (
                        <React.Fragment>
                            <br/>
                            {error}
                        </React.Fragment>
                    )
                })}
            </React.Fragment>
        )
    }

    renderTermsAndConditions = () => {
        if (!this.state || !this.state.terms) return null;

        return (
            <div
                style={{
                    height: '25em',
                    backgroundColor: 'white',
                    overflowY: 'scroll',
                    border: '1px solid lightgrey',
                    padding: '.75em 1em'
                }}
                dangerouslySetInnerHTML={{__html: this.state.terms}}/>
        )
    }

    render() {
        const {errorMessage} = this.props;
        return (
            <React.Fragment>
                <div className="pt-5 mt-5 pl-3 pr-3 lg-container">
                    <h1>BusRates.com Registration</h1>
                    <p>Thank you for your interest in joining BusRates.com!</p>
                    <ul>
                        <li>
                            Upon request, we can fax you the form instead of entering your
                            info online. Please email:{' '}
                            <a href="mailto:sales@busrates.com">sales@busrates.com</a>
                        </li>
                        <li>
                            For help, or to expedite your posting, please call 703-838-2955 M-F 9am to 5:30pm EST
                        </li>
                    </ul>
                </div>
                <div className="lg-container pt-4 pb-3 pl-3 pr-3">
                    <div style={{backgroundColor: '#e9ecef', padding: '2em'}}>
                        <h3
                            className="font-weight-bolder text-primary mb-0"
                            style={{padding: '1em 0em'}}
                        >
                            Bus Operator Registration
                        </h3>
                        <Formik
                            initialValues={{
                                national: this.props.registerParam.national,
                                address: this.props.registerParam.address,
                                addressLine2: this.props.registerParam.addressLine2,
                                certifications: this.props.registerParam.certifications,
                                companyName: this.props.registerParam.companyName,
                                companyPhone: this.props.registerParam.companyPhone,
                                companyWebsite: this.props.registerParam.companyWebsite,
                                contactName: this.props.registerParam.contactName,
                                contactPhone: this.props.registerParam.contactPhone,
                                contactPhoneExtension: this.props.registerParam.contactPhoneExtension,
                                dotNumber: this.props.registerParam.dotNumber,
                                stateAndRegional: this.props.registerParam.stateAndRegional,
                                terms: this.props.registerParam.terms,
                                zipCode: this.props.registerParam.zipCode,
                                city: this.props.registerParam.city,
                                state: this.props.registerParam.state
                            }}
                            validationSchema={validationSchema}
                            onSubmit={this.onFormSubmit}
                            render={formProps => (
                                <Form onSubmit={formProps.handleSubmit}>
                                    <h4 className="text-primary">Payment Information</h4>
                                    <hr/>
                                    <Row>
                                        <InputSelect
                                            className="col-12 col-md-6"
                                            label="Account Status"
                                            name="accountStatus"
                                            optionKey="key"
                                            optionLabel="value"
                                            options={this.accountStatusOptions()}
                                            optionValue="key"
                                            required
                                            {...formProps}
                                        />
                                    </Row>
                                    <Row>
                                        <InputSelect
                                            className="col-12 col-md-6"
                                            label="CC Recurring"
                                            name="ccRecurring"
                                            optionKey="key"
                                            optionLabel="value"
                                            options={this.ccRecurringOptions()}
                                            optionValue="key"
                                            required
                                            {...formProps}
                                        />
                                    </Row>
                                    <Row>
                                        <InputSelect
                                            className="col-12 col-md-6"
                                            label="Payment Option"
                                            name="paymentOption"
                                            optionKey="key"
                                            optionLabel="value"
                                            options={this.paymentOptions()}
                                            optionValue="key"
                                            required
                                            {...formProps}
                                        />
                                    </Row>
                                    <hr/>
                                    {formProps.dirty && !formProps.isValid && (
                                        <div className="text-danger text-center mt-3">
                                            Some fields are invalid, please check all fields and try again
                                            {this.renderErrors(formProps.errors)}
                                        </div>)
                                    }
                                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                                    <Button disabled={this.state.nextDisabled} style={{color: 'white'}} className={this.state.loadingCssName}
                                            id={"submitBtn"}>Next</Button>
                                </Form>
                            )}
                        />
                    </div>
                </div>
                <Footer/>
            </React.Fragment>
        );
    }
}

Yup.addMethod(Yup.mixed, 'sameAs', function (ref, message) {
    return this.test('sameAs', message, function (value) {
        const other = this.resolve(ref);
        return !other || !value || value === other;
    });
});

const validationSchema = Yup.object().shape({
    accountStatus: Yup.string().required('Account Status is required.'),
    ccRecurring: Yup.string().required('CC Recurring is required.'),
    paymentOption: Yup.string().required('CC Recurring is required.')
});

const mapStateToProps = ({subscribe: {errorMessage, registerParam}}) => ({
        errorMessage,
        registerParam
});

export default connect(mapStateToProps, {
    toRegisterConfirmPage
})(SubscribePayment);
